import React, { FC, memo } from 'react'

import { Outlet } from 'react-router-dom'

import { isDevMode } from '@sportworld/js-sdk/src/envs/envs'

import { SettingsSidebar } from '@/components/SettingsSidebar/SettingsSidebar'
import { focusIds } from '@/constants/focus'
import { Container } from '@/layouts/styles'
import { logStartupTime } from '@/utils/utils'

isDevMode && logStartupTime()

const SettingsLayoutRaw: FC = () => {
  return (
    <>
      <SettingsSidebar />
      <Container focusId={focusIds.CONTENT} elementType="main">
        <Outlet />
      </Container>
    </>
  )
}

export const SettingsLayout = memo(SettingsLayoutRaw)
